export default __webpack_public_path__ + "static/media/056-road.ae8fd707.png";